module.exports = __webpack_public_path__ + "static/media/circular-loading.1e53ff63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/circular-loading.svg
// module id = 2326
// module chunks = 0